import {
  Drawer,
  DrawerContent,
  DrawerDescription,
  DrawerHeader,
  DrawerTitle,
  DrawerFooter,
} from '@sakura-grp/ui/drawer';
import { Button } from '@sakura-grp/ui/button';
import { useCancelActivity } from '@/hooks/useActivities';
import { AlertTriangle } from 'lucide-react';

interface CancelActivitySheetProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  activity: {
    id: string;
    date: string;
    type: string;
    storeName?: string;
    customerName?: string;
  } | null;
  hostessId: string;
}

export function CancelActivitySheet({
  open,
  onOpenChange,
  activity,
  hostessId,
}: CancelActivitySheetProps) {
  const cancelActivity = useCancelActivity();

  const handleCancel = () => {
    if (!activity) return;

    cancelActivity.mutate(
      {
        id: activity.id,
        hostessId,
        cancelReason: '誤タップ',
      },
      {
        onSuccess: () => {
          onOpenChange(false);
        },
      }
    );
  };

  if (!activity) return null;

  return (
    <Drawer open={open} onOpenChange={onOpenChange}>
      <DrawerContent className="px-lg pb-safe-min">
        <DrawerHeader className="pb-md">
          <DrawerTitle className="flex items-center gap-2">
            <AlertTriangle className="size-5 text-warning" />
            営業活動報告を取り消す
          </DrawerTitle>
          <DrawerDescription>この営業活動報告を取り消しますか？</DrawerDescription>
        </DrawerHeader>

        <div className="space-y-4">
          <div className="rounded-lg bg-gray-50 p-3 text-sm">
            {activity.storeName && (
              <p><span className="text-gray-500">店舗:</span> {activity.storeName}</p>
            )}
            <p><span className="text-gray-500">日付:</span> {activity.date}</p>
            <p><span className="text-gray-500">種別:</span> {activity.type}</p>
            {activity.customerName && (
              <p><span className="text-gray-500">顧客:</span> {activity.customerName}</p>
            )}
          </div>
          <p className="text-xs text-gray-500">
            ※ 取り消し後は元に戻せません。間違えた場合は、再度活動を報告してください。
          </p>
        </div>

        <DrawerFooter className="p-0 pt-md flex flex-col gap-md">
          <Button
            variant="destructive"
            onClick={handleCancel}
            disabled={cancelActivity.isPending}
          >
            {cancelActivity.isPending ? '取消中...' : '取消する'}
          </Button>
          <Button
            variant="outline"
            onClick={() => onOpenChange(false)}
            disabled={cancelActivity.isPending}
          >
            やめる
          </Button>
        </DrawerFooter>
      </DrawerContent>
    </Drawer>
  );
}
